// source: no/jotta/openapi/customer/customer.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_ref_pb = require('../../../../no/jotta/openapi/ref_pb.js');
goog.object.extend(proto, no_jotta_openapi_ref_pb);
var no_jotta_openapi_credentials_pb = require('../../../../no/jotta/openapi/credentials_pb.js');
goog.object.extend(proto, no_jotta_openapi_credentials_pb);
var no_jotta_openapi_language_pb = require('../../../../no/jotta/openapi/language_pb.js');
goog.object.extend(proto, no_jotta_openapi_language_pb);
var no_jotta_openapi_country_pb = require('../../../../no/jotta/openapi/country_pb.js');
goog.object.extend(proto, no_jotta_openapi_country_pb);
var no_jotta_openapi_auth_v2_auth_v2_pb = require('../../../../no/jotta/openapi/auth/v2/auth.v2_pb.js');
goog.object.extend(proto, no_jotta_openapi_auth_v2_auth_v2_pb);
var no_jotta_openapi_file_file_v2_pb = require('../../../../no/jotta/openapi/file/file.v2_pb.js');
goog.object.extend(proto, no_jotta_openapi_file_file_v2_pb);
var no_jotta_openapi_wopi_pb = require('../../../../no/jotta/openapi/wopi_pb.js');
goog.object.extend(proto, no_jotta_openapi_wopi_pb);
var no_jotta_openapi_avatar_pb = require('../../../../no/jotta/openapi/avatar_pb.js');
goog.object.extend(proto, no_jotta_openapi_avatar_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var no_jotta_protobuf_wrappers_pb = require('../../../../no/jotta/protobuf/wrappers_pb.js');
goog.object.extend(proto, no_jotta_protobuf_wrappers_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.AccountLock', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.AccountType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.ApproveLoginRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.ApproveLoginResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.BrandingInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Business', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.ChangeEmailRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.ChangeEmailResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.CreateInvite', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.CreateInvite.InviteCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Customer', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Customer.OnBoarding', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Customer.TFAType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Family', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.FamilyInvite', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.FamilyInvite.SendAddressCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.GetCustomerRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.GetCustomerResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.GetFamilyRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.GetFamilyResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.IntercomConfig', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.InviteState', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.LanguageValue', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.LockCause', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Message', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Message.Importance', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.Message.Type', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.PatchCustomerRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.PatchCustomerResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.ResponseCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.PhotoState', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.QuotaState', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.SubscriptionType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.TerminateAccountRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.TerminateAccountResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.TerminationSurveyCategory', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.UserSettings', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.WebSettings', null, global);
goog.exportSymbol('proto.no.jotta.openapi.customer.v2.WebSettings.ViewMode', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.BrandingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.BrandingInfo.displayName = 'proto.no.jotta.openapi.customer.v2.BrandingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.Business = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.Business, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.Business.displayName = 'proto.no.jotta.openapi.customer.v2.Business';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.Family = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.Family, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.Family.displayName = 'proto.no.jotta.openapi.customer.v2.Family';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.AccountLock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.AccountLock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.AccountLock.displayName = 'proto.no.jotta.openapi.customer.v2.AccountLock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.IntercomConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.IntercomConfig.displayName = 'proto.no.jotta.openapi.customer.v2.IntercomConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.WebSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.WebSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.WebSettings.displayName = 'proto.no.jotta.openapi.customer.v2.WebSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.UserSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.UserSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.UserSettings.displayName = 'proto.no.jotta.openapi.customer.v2.UserSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.Message = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.Message, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.Message.displayName = 'proto.no.jotta.openapi.customer.v2.Message';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.Customer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.customer.v2.Customer.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.Customer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.Customer.displayName = 'proto.no.jotta.openapi.customer.v2.Customer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.Customer.OnBoarding, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.displayName = 'proto.no.jotta.openapi.customer.v2.Customer.OnBoarding';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.GetCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.GetCustomerRequest.displayName = 'proto.no.jotta.openapi.customer.v2.GetCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.GetCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.GetCustomerResponse.displayName = 'proto.no.jotta.openapi.customer.v2.GetCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.LanguageValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.LanguageValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.LanguageValue.displayName = 'proto.no.jotta.openapi.customer.v2.LanguageValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.PatchCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.displayName = 'proto.no.jotta.openapi.customer.v2.PatchCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.PatchCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.displayName = 'proto.no.jotta.openapi.customer.v2.PatchCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.FamilyInvite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.FamilyInvite.displayName = 'proto.no.jotta.openapi.customer.v2.FamilyInvite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.CreateInvite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.customer.v2.CreateInvite.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.CreateInvite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.CreateInvite.displayName = 'proto.no.jotta.openapi.customer.v2.CreateInvite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.displayName = 'proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.displayName = 'proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.displayName = 'proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.displayName = 'proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.GetFamilyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.GetFamilyRequest.displayName = 'proto.no.jotta.openapi.customer.v2.GetFamilyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.customer.v2.GetFamilyResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.GetFamilyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.GetFamilyResponse.displayName = 'proto.no.jotta.openapi.customer.v2.GetFamilyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.ChangeEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.displayName = 'proto.no.jotta.openapi.customer.v2.ChangeEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.ChangeEmailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.displayName = 'proto.no.jotta.openapi.customer.v2.ChangeEmailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.TerminateAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.displayName = 'proto.no.jotta.openapi.customer.v2.TerminateAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.displayName = 'proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.TerminateAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.displayName = 'proto.no.jotta.openapi.customer.v2.TerminateAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.displayName = 'proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.displayName = 'proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.displayName = 'proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.displayName = 'proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.displayName = 'proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.displayName = 'proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.displayName = 'proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.displayName = 'proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.ApproveLoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.displayName = 'proto.no.jotta.openapi.customer.v2.ApproveLoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.ApproveLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.displayName = 'proto.no.jotta.openapi.customer.v2.ApproveLoginResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.displayName = 'proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.displayName = 'proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.BrandingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.BrandingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    customerGroupCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    customerGroupName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.BrandingInfo}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.BrandingInfo;
  return proto.no.jotta.openapi.customer.v2.BrandingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.BrandingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.BrandingInfo}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.BrandingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.BrandingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerGroupCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomerGroupName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string brand_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.getBrandCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.BrandingInfo} returns this
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.setBrandCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.BrandingInfo} returns this
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string customer_group_code = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.getCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.BrandingInfo} returns this
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.setCustomerGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string customer_group_name = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.getCustomerGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.BrandingInfo} returns this
 */
proto.no.jotta.openapi.customer.v2.BrandingInfo.prototype.setCustomerGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.Business.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.Business} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Business.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    country: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maxUserCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.Business}
 */
proto.no.jotta.openapi.customer.v2.Business.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.Business;
  return proto.no.jotta.openapi.customer.v2.Business.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.Business} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.Business}
 */
proto.no.jotta.openapi.customer.v2.Business.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgNo(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.Country} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxUserCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.Business.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.Business} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Business.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getMaxUserCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Business} returns this
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string org_no = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.getOrgNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Business} returns this
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.setOrgNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional no.jotta.openapi.Country country = 3;
 * @return {!proto.no.jotta.openapi.Country}
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.getCountry = function() {
  return /** @type {!proto.no.jotta.openapi.Country} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Country} value
 * @return {!proto.no.jotta.openapi.customer.v2.Business} returns this
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 max_user_count = 4;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.getMaxUserCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.Business} returns this
 */
proto.no.jotta.openapi.customer.v2.Business.prototype.setMaxUserCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.Family.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.Family.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.Family} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Family.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.Family}
 */
proto.no.jotta.openapi.customer.v2.Family.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.Family;
  return proto.no.jotta.openapi.customer.v2.Family.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.Family} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.Family}
 */
proto.no.jotta.openapi.customer.v2.Family.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.Family.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.Family.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.Family} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Family.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Family.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Family} returns this
 */
proto.no.jotta.openapi.customer.v2.Family.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.AccountLock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.AccountLock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.AccountLock.toObject = function(includeInstance, msg) {
  var f, obj = {
    isWriteLocked: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    isReadLocked: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    cause: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.AccountLock}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.AccountLock;
  return proto.no.jotta.openapi.customer.v2.AccountLock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.AccountLock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.AccountLock}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWriteLocked(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsReadLocked(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.LockCause} */ (reader.readEnum());
      msg.setCause(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.AccountLock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.AccountLock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.AccountLock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsWriteLocked();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsReadLocked();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCause();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional bool is_write_locked = 1;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.getIsWriteLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.AccountLock} returns this
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.setIsWriteLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool is_read_locked = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.getIsReadLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.AccountLock} returns this
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.setIsReadLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional LockCause cause = 3;
 * @return {!proto.no.jotta.openapi.customer.v2.LockCause}
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.getCause = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.LockCause} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.LockCause} value
 * @return {!proto.no.jotta.openapi.customer.v2.AccountLock} returns this
 */
proto.no.jotta.openapi.customer.v2.AccountLock.prototype.setCause = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.IntercomConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.IntercomConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    webHash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    androidHash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iosHash: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.IntercomConfig}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.IntercomConfig;
  return proto.no.jotta.openapi.customer.v2.IntercomConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.IntercomConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.IntercomConfig}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAndroidHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIosHash(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.IntercomConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.IntercomConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAndroidHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIosHash();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string web_hash = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.getWebHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.IntercomConfig} returns this
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.setWebHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string android_hash = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.getAndroidHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.IntercomConfig} returns this
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.setAndroidHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ios_hash = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.getIosHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.IntercomConfig} returns this
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.setIosHash = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string app_id = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.getAppId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.IntercomConfig} returns this
 */
proto.no.jotta.openapi.customer.v2.IntercomConfig.prototype.setAppId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.WebSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.WebSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.WebSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewMode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sortMode: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.WebSettings}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.WebSettings;
  return proto.no.jotta.openapi.customer.v2.WebSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.WebSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.WebSettings}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.WebSettings.ViewMode} */ (reader.readEnum());
      msg.setViewMode(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort} */ (reader.readEnum());
      msg.setSortMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.WebSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.WebSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.WebSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSortMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.ViewMode = {
  LIST: 0,
  GRID: 1
};

/**
 * optional ViewMode view_mode = 1;
 * @return {!proto.no.jotta.openapi.customer.v2.WebSettings.ViewMode}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.prototype.getViewMode = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.WebSettings.ViewMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.WebSettings.ViewMode} value
 * @return {!proto.no.jotta.openapi.customer.v2.WebSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.WebSettings.prototype.setViewMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional no.jotta.openapi.file.v2.GetPathRequest.Sort sort_mode = 2;
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort}
 */
proto.no.jotta.openapi.customer.v2.WebSettings.prototype.getSortMode = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort} value
 * @return {!proto.no.jotta.openapi.customer.v2.WebSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.WebSettings.prototype.setSortMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.UserSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.UserSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.UserSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    excessiveTrashWarningEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    appActivityNotificationsEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    emailActivityNotificationsEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    newsletterEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    webSettings: (f = msg.getWebSettings()) && proto.no.jotta.openapi.customer.v2.WebSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.UserSettings;
  return proto.no.jotta.openapi.customer.v2.UserSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.UserSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcessiveTrashWarningEnabled(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAppActivityNotificationsEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailActivityNotificationsEnabled(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewsletterEnabled(value);
      break;
    case 5:
      var value = new proto.no.jotta.openapi.customer.v2.WebSettings;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.WebSettings.deserializeBinaryFromReader);
      msg.setWebSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.UserSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.UserSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.UserSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExcessiveTrashWarningEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAppActivityNotificationsEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getEmailActivityNotificationsEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getNewsletterEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getWebSettings();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.no.jotta.openapi.customer.v2.WebSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool excessive_trash_warning_enabled = 1;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.getExcessiveTrashWarningEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.setExcessiveTrashWarningEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool app_activity_notifications_enabled = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.getAppActivityNotificationsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.setAppActivityNotificationsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool email_activity_notifications_enabled = 3;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.getEmailActivityNotificationsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.setEmailActivityNotificationsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool newsletter_enabled = 4;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.getNewsletterEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.setNewsletterEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional WebSettings web_settings = 5;
 * @return {?proto.no.jotta.openapi.customer.v2.WebSettings}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.getWebSettings = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.WebSettings} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.WebSettings, 5));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.WebSettings|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings} returns this
*/
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.setWebSettings = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.UserSettings} returns this
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.clearWebSettings = function() {
  return this.setWebSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.UserSettings.prototype.hasWebSettings = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.Message.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.Message} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Message.toObject = function(includeInstance, msg) {
  var f, obj = {
    localizedTitle: jspb.Message.getFieldWithDefault(msg, 4, ""),
    localizedMessage: jspb.Message.getFieldWithDefault(msg, 1, ""),
    importance: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ref: (f = msg.getRef()) && no_jotta_openapi_ref_pb.ContentRef.toObject(includeInstance, f),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 3, ""),
    localizedButtonText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    type: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.Message}
 */
proto.no.jotta.openapi.customer.v2.Message.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.Message;
  return proto.no.jotta.openapi.customer.v2.Message.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.Message}
 */
proto.no.jotta.openapi.customer.v2.Message.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalizedTitle(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalizedMessage(value);
      break;
    case 6:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.Message.Importance} */ (reader.readEnum());
      msg.setImportance(value);
      break;
    case 2:
      var value = new no_jotta_openapi_ref_pb.ContentRef;
      reader.readMessage(value,no_jotta_openapi_ref_pb.ContentRef.deserializeBinaryFromReader);
      msg.setRef(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalizedButtonText(value);
      break;
    case 7:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.Message.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Message.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocalizedTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLocalizedMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImportance();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRef();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      no_jotta_openapi_ref_pb.ContentRef.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {!proto.no.jotta.openapi.customer.v2.Message.Type} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.Message.Importance = {
  UNKNOWN_IMPORTANCE: 0,
  CRITICAL: 1,
  WARNING: 2,
  INFO: 3
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.Message.Type = {
  UNKNOWN_MESSAGE_TYPE: 0,
  OUT_OF_STORAGE: 1
};

/**
 * optional string localized_title = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getLocalizedTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.setLocalizedTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string localized_message = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getLocalizedMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.setLocalizedMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Importance importance = 6;
 * @return {!proto.no.jotta.openapi.customer.v2.Message.Importance}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getImportance = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.Message.Importance} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.Message.Importance} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.setImportance = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional no.jotta.openapi.ContentRef ref = 2;
 * @return {?proto.no.jotta.openapi.ContentRef}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getRef = function() {
  return /** @type{?proto.no.jotta.openapi.ContentRef} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_ref_pb.ContentRef, 2));
};


/**
 * @param {?proto.no.jotta.openapi.ContentRef|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
*/
proto.no.jotta.openapi.customer.v2.Message.prototype.setRef = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.clearRef = function() {
  return this.setRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.hasRef = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string encoded_content_ref = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.clearEncodedContentRef = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.hasEncodedContentRef = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string localized_button_text = 5;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getLocalizedButtonText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.setLocalizedButtonText = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.clearLocalizedButtonText = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.hasLocalizedButtonText = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Type type = 7;
 * @return {!proto.no.jotta.openapi.customer.v2.Message.Type}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.getType = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.Message.Type} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.Message.Type} value
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.setType = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Message} returns this
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.clearType = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Message.prototype.hasType = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.customer.v2.Customer.repeatedFields_ = [22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.Customer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Customer.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fullName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phoneNumberVerified: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    countryCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    country: jspb.Message.getFieldWithDefault(msg, 29, 0),
    languageCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    language: jspb.Message.getFieldWithDefault(msg, 19, 0),
    usageBytes: jspb.Message.getFieldWithDefault(msg, 8, 0),
    quotaBytes: jspb.Message.getFieldWithDefault(msg, 9, 0),
    photoState: jspb.Message.getFieldWithDefault(msg, 18, 0),
    accountType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    subscriptionType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    brandingInfo: (f = msg.getBrandingInfo()) && proto.no.jotta.openapi.customer.v2.BrandingInfo.toObject(includeInstance, f),
    accountLock: (f = msg.getAccountLock()) && proto.no.jotta.openapi.customer.v2.AccountLock.toObject(includeInstance, f),
    intercom: (f = msg.getIntercom()) && proto.no.jotta.openapi.customer.v2.IntercomConfig.toObject(includeInstance, f),
    userSettings: (f = msg.getUserSettings()) && proto.no.jotta.openapi.customer.v2.UserSettings.toObject(includeInstance, f),
    business: (f = msg.getBusiness()) && proto.no.jotta.openapi.customer.v2.Business.toObject(includeInstance, f),
    family: (f = msg.getFamily()) && proto.no.jotta.openapi.customer.v2.Family.toObject(includeInstance, f),
    wopiConsent: jspb.Message.getFieldWithDefault(msg, 20, 0),
    tfaType: jspb.Message.getFieldWithDefault(msg, 21, 0),
    messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.no.jotta.openapi.customer.v2.Message.toObject, includeInstance),
    promoteUpgrade: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    canTerminateAccount: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    quota: jspb.Message.getFieldWithDefault(msg, 25, 0),
    onboarding: (f = msg.getOnboarding()) && proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.toObject(includeInstance, f),
    avatar: (f = msg.getAvatar()) && no_jotta_openapi_avatar_pb.Avatar.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer}
 */
proto.no.jotta.openapi.customer.v2.Customer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.Customer;
  return proto.no.jotta.openapi.customer.v2.Customer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer}
 */
proto.no.jotta.openapi.customer.v2.Customer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhoneNumberVerified(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 29:
      var value = /** @type {!proto.no.jotta.openapi.Country} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguageCode(value);
      break;
    case 19:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsageBytes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuotaBytes(value);
      break;
    case 18:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.PhotoState} */ (reader.readEnum());
      msg.setPhotoState(value);
      break;
    case 10:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.AccountType} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 11:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.SubscriptionType} */ (reader.readEnum());
      msg.setSubscriptionType(value);
      break;
    case 12:
      var value = new proto.no.jotta.openapi.customer.v2.BrandingInfo;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.BrandingInfo.deserializeBinaryFromReader);
      msg.setBrandingInfo(value);
      break;
    case 13:
      var value = new proto.no.jotta.openapi.customer.v2.AccountLock;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.AccountLock.deserializeBinaryFromReader);
      msg.setAccountLock(value);
      break;
    case 14:
      var value = new proto.no.jotta.openapi.customer.v2.IntercomConfig;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.IntercomConfig.deserializeBinaryFromReader);
      msg.setIntercom(value);
      break;
    case 15:
      var value = new proto.no.jotta.openapi.customer.v2.UserSettings;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.UserSettings.deserializeBinaryFromReader);
      msg.setUserSettings(value);
      break;
    case 16:
      var value = new proto.no.jotta.openapi.customer.v2.Business;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Business.deserializeBinaryFromReader);
      msg.setBusiness(value);
      break;
    case 17:
      var value = new proto.no.jotta.openapi.customer.v2.Family;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Family.deserializeBinaryFromReader);
      msg.setFamily(value);
      break;
    case 20:
      var value = /** @type {!proto.no.jotta.openapi.WopiConsent} */ (reader.readEnum());
      msg.setWopiConsent(value);
      break;
    case 21:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.Customer.TFAType} */ (reader.readEnum());
      msg.setTfaType(value);
      break;
    case 22:
      var value = new proto.no.jotta.openapi.customer.v2.Message;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Message.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPromoteUpgrade(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanTerminateAccount(value);
      break;
    case 25:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.QuotaState} */ (reader.readEnum());
      msg.setQuota(value);
      break;
    case 26:
      var value = new proto.no.jotta.openapi.customer.v2.Customer.OnBoarding;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.deserializeBinaryFromReader);
      msg.setOnboarding(value);
      break;
    case 28:
      var value = new no_jotta_openapi_avatar_pb.Avatar;
      reader.readMessage(value,no_jotta_openapi_avatar_pb.Avatar.deserializeBinaryFromReader);
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.Customer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Customer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhoneNumberVerified();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      29,
      f
    );
  }
  f = message.getLanguageCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getUsageBytes();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getQuotaBytes();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getPhotoState();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getSubscriptionType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getBrandingInfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.no.jotta.openapi.customer.v2.BrandingInfo.serializeBinaryToWriter
    );
  }
  f = message.getAccountLock();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.no.jotta.openapi.customer.v2.AccountLock.serializeBinaryToWriter
    );
  }
  f = message.getIntercom();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.no.jotta.openapi.customer.v2.IntercomConfig.serializeBinaryToWriter
    );
  }
  f = message.getUserSettings();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.no.jotta.openapi.customer.v2.UserSettings.serializeBinaryToWriter
    );
  }
  f = message.getBusiness();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.no.jotta.openapi.customer.v2.Business.serializeBinaryToWriter
    );
  }
  f = message.getFamily();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.no.jotta.openapi.customer.v2.Family.serializeBinaryToWriter
    );
  }
  f = message.getWopiConsent();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getTfaType();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      proto.no.jotta.openapi.customer.v2.Message.serializeBinaryToWriter
    );
  }
  f = message.getPromoteUpgrade();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getCanTerminateAccount();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getQuota();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getOnboarding();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.serializeBinaryToWriter
    );
  }
  f = message.getAvatar();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      no_jotta_openapi_avatar_pb.Avatar.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.Customer.TFAType = {
  NONE: 0,
  TOTP: 1,
  SMS: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.Customer.OnBoarding} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusMap: (f = msg.getStatusMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer.OnBoarding}
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.Customer.OnBoarding;
  return proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.Customer.OnBoarding} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer.OnBoarding}
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getStatusMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readBool, null, "", false);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.Customer.OnBoarding} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatusMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeBool);
  }
};


/**
 * map<string, bool> status = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,boolean>}
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.prototype.getStatusMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,boolean>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer.OnBoarding} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.OnBoarding.prototype.clearStatusMap = function() {
  this.getStatusMap().clear();
  return this;
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string full_name = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone_number = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearPhoneNumber = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasPhoneNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool phone_number_verified = 5;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getPhoneNumberVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setPhoneNumberVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string country_code = 6;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional no.jotta.openapi.Country country = 29;
 * @return {!proto.no.jotta.openapi.Country}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getCountry = function() {
  return /** @type {!proto.no.jotta.openapi.Country} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Country} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 29, value);
};


/**
 * optional string language_code = 7;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getLanguageCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setLanguageCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional no.jotta.openapi.Language language = 19;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional int64 usage_bytes = 8;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getUsageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setUsageBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 quota_bytes = 9;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getQuotaBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setQuotaBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional PhotoState photo_state = 18;
 * @return {!proto.no.jotta.openapi.customer.v2.PhotoState}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getPhotoState = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.PhotoState} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.PhotoState} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setPhotoState = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional AccountType account_type = 10;
 * @return {!proto.no.jotta.openapi.customer.v2.AccountType}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getAccountType = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.AccountType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.AccountType} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional SubscriptionType subscription_type = 11;
 * @return {!proto.no.jotta.openapi.customer.v2.SubscriptionType}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getSubscriptionType = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.SubscriptionType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.SubscriptionType} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setSubscriptionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional BrandingInfo branding_info = 12;
 * @return {?proto.no.jotta.openapi.customer.v2.BrandingInfo}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getBrandingInfo = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.BrandingInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.BrandingInfo, 12));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.BrandingInfo|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setBrandingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearBrandingInfo = function() {
  return this.setBrandingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasBrandingInfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AccountLock account_lock = 13;
 * @return {?proto.no.jotta.openapi.customer.v2.AccountLock}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getAccountLock = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.AccountLock} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.AccountLock, 13));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.AccountLock|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setAccountLock = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearAccountLock = function() {
  return this.setAccountLock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasAccountLock = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional IntercomConfig intercom = 14;
 * @return {?proto.no.jotta.openapi.customer.v2.IntercomConfig}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getIntercom = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.IntercomConfig} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.IntercomConfig, 14));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.IntercomConfig|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setIntercom = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearIntercom = function() {
  return this.setIntercom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasIntercom = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional UserSettings user_settings = 15;
 * @return {?proto.no.jotta.openapi.customer.v2.UserSettings}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getUserSettings = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.UserSettings} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.UserSettings, 15));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.UserSettings|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setUserSettings = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearUserSettings = function() {
  return this.setUserSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasUserSettings = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Business business = 16;
 * @return {?proto.no.jotta.openapi.customer.v2.Business}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getBusiness = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.Business} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.Business, 16));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.Business|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setBusiness = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearBusiness = function() {
  return this.setBusiness(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasBusiness = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Family family = 17;
 * @return {?proto.no.jotta.openapi.customer.v2.Family}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getFamily = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.Family} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.Family, 17));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.Family|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setFamily = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearFamily = function() {
  return this.setFamily(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasFamily = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional no.jotta.openapi.WopiConsent wopi_consent = 20;
 * @return {!proto.no.jotta.openapi.WopiConsent}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getWopiConsent = function() {
  return /** @type {!proto.no.jotta.openapi.WopiConsent} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.no.jotta.openapi.WopiConsent} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setWopiConsent = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional TFAType tfa_type = 21;
 * @return {!proto.no.jotta.openapi.customer.v2.Customer.TFAType}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getTfaType = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.Customer.TFAType} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.Customer.TFAType} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setTfaType = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * repeated Message messages = 22;
 * @return {!Array<!proto.no.jotta.openapi.customer.v2.Message>}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.customer.v2.Message>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.customer.v2.Message, 22));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.customer.v2.Message>} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.Message=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.customer.v2.Message}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.no.jotta.openapi.customer.v2.Message, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};


/**
 * optional bool promote_upgrade = 23;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getPromoteUpgrade = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setPromoteUpgrade = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool can_terminate_account = 24;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getCanTerminateAccount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setCanTerminateAccount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional QuotaState quota = 25;
 * @return {!proto.no.jotta.openapi.customer.v2.QuotaState}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getQuota = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.QuotaState} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.QuotaState} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.setQuota = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional OnBoarding onboarding = 26;
 * @return {?proto.no.jotta.openapi.customer.v2.Customer.OnBoarding}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getOnboarding = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.Customer.OnBoarding} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.Customer.OnBoarding, 26));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.Customer.OnBoarding|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setOnboarding = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearOnboarding = function() {
  return this.setOnboarding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasOnboarding = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional no.jotta.openapi.Avatar avatar = 28;
 * @return {?proto.no.jotta.openapi.Avatar}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.getAvatar = function() {
  return /** @type{?proto.no.jotta.openapi.Avatar} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_avatar_pb.Avatar, 28));
};


/**
 * @param {?proto.no.jotta.openapi.Avatar|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
*/
proto.no.jotta.openapi.customer.v2.Customer.prototype.setAvatar = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.Customer} returns this
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.clearAvatar = function() {
  return this.setAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.Customer.prototype.hasAvatar = function() {
  return jspb.Message.getField(this, 28) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.GetCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.GetCustomerRequest;
  return proto.no.jotta.openapi.customer.v2.GetCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.GetCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.Language language = 1;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.GetCustomerRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.GetCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.no.jotta.openapi.customer.v2.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.GetCustomerResponse;
  return proto.no.jotta.openapi.customer.v2.GetCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.customer.v2.Customer;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.GetCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.customer.v2.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.no.jotta.openapi.customer.v2.Customer}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.prototype.getCustomer = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.Customer} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.Customer, 1));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.Customer|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.GetCustomerResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.GetCustomerResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.LanguageValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.LanguageValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.LanguageValue}
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.LanguageValue;
  return proto.no.jotta.openapi.customer.v2.LanguageValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.LanguageValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.LanguageValue}
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.LanguageValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.LanguageValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.Language language = 1;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.customer.v2.LanguageValue} returns this
 */
proto.no.jotta.openapi.customer.v2.LanguageValue.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    responseLanguage: jspb.Message.getFieldWithDefault(msg, 1, 0),
    credentials: (f = msg.getCredentials()) && no_jotta_openapi_credentials_pb.Credentials.toObject(includeInstance, f),
    email: (f = msg.getEmail()) && no_jotta_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    password: (f = msg.getPassword()) && no_jotta_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    phoneNumber: (f = msg.getPhoneNumber()) && no_jotta_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    excessiveTrashWarningEnabled: (f = msg.getExcessiveTrashWarningEnabled()) && no_jotta_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    appActivityNotificationsEnabled: (f = msg.getAppActivityNotificationsEnabled()) && no_jotta_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    emailActivityNotificationsEnabled: (f = msg.getEmailActivityNotificationsEnabled()) && no_jotta_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    newsletterEnabled: (f = msg.getNewsletterEnabled()) && no_jotta_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    name: (f = msg.getName()) && no_jotta_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && no_jotta_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    language: (f = msg.getLanguage()) && proto.no.jotta.openapi.customer.v2.LanguageValue.toObject(includeInstance, f),
    profilePhoto: (f = msg.getProfilePhoto()) && google_protobuf_wrappers_pb.BytesValue.toObject(includeInstance, f),
    webSettings: (f = msg.getWebSettings()) && proto.no.jotta.openapi.customer.v2.WebSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.PatchCustomerRequest;
  return proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setResponseLanguage(value);
      break;
    case 18:
      var value = new no_jotta_openapi_credentials_pb.Credentials;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Credentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    case 19:
      var value = new no_jotta_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 20:
      var value = new no_jotta_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPassword(value);
      break;
    case 21:
      var value = new no_jotta_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhoneNumber(value);
      break;
    case 10:
      var value = new no_jotta_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setExcessiveTrashWarningEnabled(value);
      break;
    case 11:
      var value = new no_jotta_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAppActivityNotificationsEnabled(value);
      break;
    case 12:
      var value = new no_jotta_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEmailActivityNotificationsEnabled(value);
      break;
    case 13:
      var value = new no_jotta_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setNewsletterEnabled(value);
      break;
    case 14:
      var value = new no_jotta_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 15:
      var value = new no_jotta_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 17:
      var value = new proto.no.jotta.openapi.customer.v2.LanguageValue;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.LanguageValue.deserializeBinaryFromReader);
      msg.setLanguage(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BytesValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BytesValue.deserializeBinaryFromReader);
      msg.setProfilePhoto(value);
      break;
    case 23:
      var value = new proto.no.jotta.openapi.customer.v2.WebSettings;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.WebSettings.deserializeBinaryFromReader);
      msg.setWebSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponseLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      no_jotta_openapi_credentials_pb.Credentials.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      no_jotta_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPassword();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      no_jotta_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumber();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      no_jotta_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExcessiveTrashWarningEnabled();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      no_jotta_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getAppActivityNotificationsEnabled();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      no_jotta_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEmailActivityNotificationsEnabled();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      no_jotta_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getNewsletterEnabled();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      no_jotta_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      no_jotta_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      no_jotta_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.no.jotta.openapi.customer.v2.LanguageValue.serializeBinaryToWriter
    );
  }
  f = message.getProfilePhoto();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BytesValue.serializeBinaryToWriter
    );
  }
  f = message.getWebSettings();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.no.jotta.openapi.customer.v2.WebSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Language response_language = 1;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getResponseLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setResponseLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional no.jotta.openapi.Credentials credentials = 18;
 * @return {?proto.no.jotta.openapi.Credentials}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getCredentials = function() {
  return /** @type{?proto.no.jotta.openapi.Credentials} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Credentials, 18));
};


/**
 * @param {?proto.no.jotta.openapi.Credentials|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional no.jotta.protobuf.StringValue email = 19;
 * @return {?proto.no.jotta.protobuf.StringValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getEmail = function() {
  return /** @type{?proto.no.jotta.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.StringValue, 19));
};


/**
 * @param {?proto.no.jotta.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional no.jotta.protobuf.StringValue password = 20;
 * @return {?proto.no.jotta.protobuf.StringValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getPassword = function() {
  return /** @type{?proto.no.jotta.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.no.jotta.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setPassword = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearPassword = function() {
  return this.setPassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional no.jotta.protobuf.StringValue phone_number = 21;
 * @return {?proto.no.jotta.protobuf.StringValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getPhoneNumber = function() {
  return /** @type{?proto.no.jotta.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.no.jotta.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearPhoneNumber = function() {
  return this.setPhoneNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasPhoneNumber = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional no.jotta.protobuf.BoolValue excessive_trash_warning_enabled = 10;
 * @return {?proto.no.jotta.protobuf.BoolValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getExcessiveTrashWarningEnabled = function() {
  return /** @type{?proto.no.jotta.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.no.jotta.protobuf.BoolValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setExcessiveTrashWarningEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearExcessiveTrashWarningEnabled = function() {
  return this.setExcessiveTrashWarningEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasExcessiveTrashWarningEnabled = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional no.jotta.protobuf.BoolValue app_activity_notifications_enabled = 11;
 * @return {?proto.no.jotta.protobuf.BoolValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getAppActivityNotificationsEnabled = function() {
  return /** @type{?proto.no.jotta.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.no.jotta.protobuf.BoolValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setAppActivityNotificationsEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearAppActivityNotificationsEnabled = function() {
  return this.setAppActivityNotificationsEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasAppActivityNotificationsEnabled = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional no.jotta.protobuf.BoolValue email_activity_notifications_enabled = 12;
 * @return {?proto.no.jotta.protobuf.BoolValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getEmailActivityNotificationsEnabled = function() {
  return /** @type{?proto.no.jotta.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.BoolValue, 12));
};


/**
 * @param {?proto.no.jotta.protobuf.BoolValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setEmailActivityNotificationsEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearEmailActivityNotificationsEnabled = function() {
  return this.setEmailActivityNotificationsEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasEmailActivityNotificationsEnabled = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional no.jotta.protobuf.BoolValue newsletter_enabled = 13;
 * @return {?proto.no.jotta.protobuf.BoolValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getNewsletterEnabled = function() {
  return /** @type{?proto.no.jotta.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.no.jotta.protobuf.BoolValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setNewsletterEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearNewsletterEnabled = function() {
  return this.setNewsletterEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasNewsletterEnabled = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional no.jotta.protobuf.StringValue name = 14;
 * @return {?proto.no.jotta.protobuf.StringValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getName = function() {
  return /** @type{?proto.no.jotta.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.no.jotta.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional no.jotta.protobuf.StringValue country_code = 15;
 * @return {?proto.no.jotta.protobuf.StringValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getCountryCode = function() {
  return /** @type{?proto.no.jotta.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.no.jotta.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional LanguageValue language = 17;
 * @return {?proto.no.jotta.openapi.customer.v2.LanguageValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getLanguage = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.LanguageValue} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.LanguageValue, 17));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.LanguageValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearLanguage = function() {
  return this.setLanguage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasLanguage = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BytesValue profile_photo = 22;
 * @return {?proto.google.protobuf.BytesValue}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getProfilePhoto = function() {
  return /** @type{?proto.google.protobuf.BytesValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BytesValue, 22));
};


/**
 * @param {?proto.google.protobuf.BytesValue|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setProfilePhoto = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearProfilePhoto = function() {
  return this.setProfilePhoto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasProfilePhoto = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional WebSettings web_settings = 23;
 * @return {?proto.no.jotta.openapi.customer.v2.WebSettings}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.getWebSettings = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.WebSettings} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.WebSettings, 23));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.WebSettings|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.setWebSettings = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.clearWebSettings = function() {
  return this.setWebSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerRequest.prototype.hasWebSettings = function() {
  return jspb.Message.getField(this, 23) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.ResponseCase = {
  RESPONSE_NOT_SET: 0,
  CHALLENGES: 1,
  CUSTOMER: 2
};

/**
 * @return {proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.ResponseCase}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.getResponseCase = function() {
  return /** @type {proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.ResponseCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenges: (f = msg.getChallenges()) && no_jotta_openapi_credentials_pb.Challenges.toObject(includeInstance, f),
    customer: (f = msg.getCustomer()) && proto.no.jotta.openapi.customer.v2.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.PatchCustomerResponse;
  return proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Challenges;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Challenges.deserializeBinaryFromReader);
      msg.setChallenges(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.customer.v2.Customer;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenges();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Challenges.serializeBinaryToWriter
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.customer.v2.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Challenges challenges = 1;
 * @return {?proto.no.jotta.openapi.Challenges}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.getChallenges = function() {
  return /** @type{?proto.no.jotta.openapi.Challenges} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Challenges, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Challenges|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.setChallenges = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.clearChallenges = function() {
  return this.setChallenges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.hasChallenges = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Customer customer = 2;
 * @return {?proto.no.jotta.openapi.customer.v2.Customer}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.getCustomer = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.Customer} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.Customer, 2));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.Customer|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_ = [[10,11]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.SendAddressCase = {
  SEND_ADDRESS_NOT_SET: 0,
  EMAIL: 10,
  SMS: 11
};

/**
 * @return {proto.no.jotta.openapi.customer.v2.FamilyInvite.SendAddressCase}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getSendAddressCase = function() {
  return /** @type {proto.no.jotta.openapi.customer.v2.FamilyInvite.SendAddressCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.FamilyInvite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.FamilyInvite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sendAddressDeprecated: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sms: jspb.Message.getFieldWithDefault(msg, 11, ""),
    fromUsername: jspb.Message.getFieldWithDefault(msg, 3, ""),
    toUsername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    toUserFullname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    toAvatar: (f = msg.getToAvatar()) && no_jotta_openapi_avatar_pb.Avatar.toObject(includeInstance, f),
    inviteCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    inviteLink: jspb.Message.getFieldWithDefault(msg, 7, ""),
    fsUsageBytes: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.FamilyInvite;
  return proto.no.jotta.openapi.customer.v2.FamilyInvite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.FamilyInvite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.InviteState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendAddressDeprecated(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSms(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setToUsername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setToUserFullname(value);
      break;
    case 9:
      var value = new no_jotta_openapi_avatar_pb.Avatar;
      reader.readMessage(value,no_jotta_openapi_avatar_pb.Avatar.deserializeBinaryFromReader);
      msg.setToAvatar(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteLink(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFsUsageBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.FamilyInvite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.FamilyInvite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSendAddressDeprecated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFromUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getToUsername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getToUserFullname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getToAvatar();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      no_jotta_openapi_avatar_pb.Avatar.serializeBinaryToWriter
    );
  }
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInviteLink();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFsUsageBytes();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional InviteState state = 1;
 * @return {!proto.no.jotta.openapi.customer.v2.InviteState}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getState = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.InviteState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.InviteState} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string send_address_deprecated = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getSendAddressDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setSendAddressDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 10;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setEmail = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.clearEmail = function() {
  return jspb.Message.setOneofField(this, 10, proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string sms = 11;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getSms = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setSms = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.clearSms = function() {
  return jspb.Message.setOneofField(this, 11, proto.no.jotta.openapi.customer.v2.FamilyInvite.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.hasSms = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string from_username = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getFromUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setFromUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string to_username = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getToUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setToUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string to_user_fullname = 5;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getToUserFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setToUserFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional no.jotta.openapi.Avatar to_avatar = 9;
 * @return {?proto.no.jotta.openapi.Avatar}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getToAvatar = function() {
  return /** @type{?proto.no.jotta.openapi.Avatar} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_avatar_pb.Avatar, 9));
};


/**
 * @param {?proto.no.jotta.openapi.Avatar|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
*/
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setToAvatar = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.clearToAvatar = function() {
  return this.setToAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.hasToAvatar = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string invite_code = 6;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setInviteCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string invite_link = 7;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getInviteLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setInviteLink = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 fs_usage_bytes = 8;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.getFsUsageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.FamilyInvite.prototype.setFsUsageBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.InviteCase = {
  INVITE_NOT_SET: 0,
  EMAIL_INVITE: 1,
  SMS_INVITE: 2
};

/**
 * @return {proto.no.jotta.openapi.customer.v2.CreateInvite.InviteCase}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.getInviteCase = function() {
  return /** @type {proto.no.jotta.openapi.customer.v2.CreateInvite.InviteCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.customer.v2.CreateInvite.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.CreateInvite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailInvite: (f = msg.getEmailInvite()) && proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.toObject(includeInstance, f),
    smsInvite: (f = msg.getSmsInvite()) && proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.toObject(includeInstance, f),
    firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.CreateInvite;
  return proto.no.jotta.openapi.customer.v2.CreateInvite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.deserializeBinaryFromReader);
      msg.setEmailInvite(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.deserializeBinaryFromReader);
      msg.setSmsInvite(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.CreateInvite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailInvite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.serializeBinaryToWriter
    );
  }
  f = message.getSmsInvite();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.serializeBinaryToWriter
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite;
  return proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.toObject = function(includeInstance, msg) {
  var f, obj = {
    phonenumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite;
  return proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string phonenumber = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EmailInvite email_invite = 1;
 * @return {?proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.getEmailInvite = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite, 1));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.CreateInvite.EmailInvite|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite} returns this
*/
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.setEmailInvite = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.customer.v2.CreateInvite.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.clearEmailInvite = function() {
  return this.setEmailInvite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.hasEmailInvite = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SmsInvite sms_invite = 2;
 * @return {?proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.getSmsInvite = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite, 2));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.CreateInvite.SmsInvite|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite} returns this
*/
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.setSmsInvite = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.customer.v2.CreateInvite.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.clearSmsInvite = function() {
  return this.setSmsInvite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.hasSmsInvite = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateInvite} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateInvite.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    createInvite: (f = msg.getCreateInvite()) && proto.no.jotta.openapi.customer.v2.CreateInvite.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest;
  return proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.customer.v2.CreateInvite;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.CreateInvite.deserializeBinaryFromReader);
      msg.setCreateInvite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreateInvite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.customer.v2.CreateInvite.serializeBinaryToWriter
    );
  }
};


/**
 * optional CreateInvite create_invite = 1;
 * @return {?proto.no.jotta.openapi.customer.v2.CreateInvite}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.prototype.getCreateInvite = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.CreateInvite} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.CreateInvite, 1));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.CreateInvite|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.prototype.setCreateInvite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.prototype.clearCreateInvite = function() {
  return this.setCreateInvite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest.prototype.hasCreateInvite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, 0),
    inviteCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    inviteLink: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sendAddress: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse;
  return proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.InviteState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteLink(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInviteLink();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSendAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional InviteState state = 1;
 * @return {!proto.no.jotta.openapi.customer.v2.InviteState}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.getState = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.InviteState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.InviteState} value
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string invite_code = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.setInviteCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string invite_link = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.getInviteLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.setInviteLink = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string send_address = 4;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.getSendAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.prototype.setSendAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.GetFamilyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.GetFamilyRequest;
  return proto.no.jotta.openapi.customer.v2.GetFamilyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.GetFamilyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetFamilyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.GetFamilyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    family: (f = msg.getFamily()) && proto.no.jotta.openapi.customer.v2.Family.toObject(includeInstance, f),
    maxInvitesCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    familyQuotaBytes: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalUsageBytes: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ownerUsageBytes: jspb.Message.getFieldWithDefault(msg, 5, 0),
    invitesList: jspb.Message.toObjectList(msg.getInvitesList(),
    proto.no.jotta.openapi.customer.v2.FamilyInvite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.GetFamilyResponse;
  return proto.no.jotta.openapi.customer.v2.GetFamilyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.customer.v2.Family;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.Family.deserializeBinaryFromReader);
      msg.setFamily(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxInvitesCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFamilyQuotaBytes(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalUsageBytes(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOwnerUsageBytes(value);
      break;
    case 6:
      var value = new proto.no.jotta.openapi.customer.v2.FamilyInvite;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.FamilyInvite.deserializeBinaryFromReader);
      msg.addInvites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.GetFamilyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFamily();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.customer.v2.Family.serializeBinaryToWriter
    );
  }
  f = message.getMaxInvitesCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFamilyQuotaBytes();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalUsageBytes();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOwnerUsageBytes();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getInvitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.no.jotta.openapi.customer.v2.FamilyInvite.serializeBinaryToWriter
    );
  }
};


/**
 * optional Family family = 1;
 * @return {?proto.no.jotta.openapi.customer.v2.Family}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.getFamily = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.Family} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.Family, 1));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.Family|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.setFamily = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.clearFamily = function() {
  return this.setFamily(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.hasFamily = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 max_invites_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.getMaxInvitesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.setMaxInvitesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 family_quota_bytes = 3;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.getFamilyQuotaBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.setFamilyQuotaBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total_usage_bytes = 4;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.getTotalUsageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.setTotalUsageBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 owner_usage_bytes = 5;
 * @return {number}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.getOwnerUsageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.setOwnerUsageBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated FamilyInvite invites = 6;
 * @return {!Array<!proto.no.jotta.openapi.customer.v2.FamilyInvite>}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.getInvitesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.customer.v2.FamilyInvite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.customer.v2.FamilyInvite, 6));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.customer.v2.FamilyInvite>} value
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.setInvitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.FamilyInvite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.customer.v2.FamilyInvite}
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.addInvites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.no.jotta.openapi.customer.v2.FamilyInvite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.customer.v2.GetFamilyResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.GetFamilyResponse.prototype.clearInvitesList = function() {
  return this.setInvitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
    password: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totpCode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.ChangeEmailRequest;
  return proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotpCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotpCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string new_email = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.getNewEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.setNewEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string totp_code = 3;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.getTotpCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailRequest.prototype.setTotpCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.ChangeEmailResponse;
  return proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult = {
  CHANGE_EMAIL_UNKNOWN: 0,
  CHANGE_EMAIL_OK: 1,
  CHANGE_EMAIL_REQUIRES_OTP: 2,
  CHANGE_EMAIL_BAD_CREDENTIALS: 3
};

/**
 * optional ChangeEmailResult result = 1;
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult}
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.prototype.getResult = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult} value
 * @return {!proto.no.jotta.openapi.customer.v2.ChangeEmailResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.ChangeEmailResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    credentials: (f = msg.getCredentials()) && no_jotta_openapi_credentials_pb.Credentials.toObject(includeInstance, f),
    survey: (f = msg.getSurvey()) && proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.TerminateAccountRequest;
  return proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Credentials;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Credentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey;
      reader.readMessage(value,proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.deserializeBinaryFromReader);
      msg.setSurvey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Credentials.serializeBinaryToWriter
    );
  }
  f = message.getSurvey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, 0),
    comment: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey;
  return proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.customer.v2.TerminationSurveyCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TerminationSurveyCategory category = 1;
 * @return {!proto.no.jotta.openapi.customer.v2.TerminationSurveyCategory}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.prototype.getCategory = function() {
  return /** @type {!proto.no.jotta.openapi.customer.v2.TerminationSurveyCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.TerminationSurveyCategory} value
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey} returns this
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string comment = 2;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey} returns this
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional no.jotta.openapi.Credentials credentials = 1;
 * @return {?proto.no.jotta.openapi.Credentials}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.getCredentials = function() {
  return /** @type{?proto.no.jotta.openapi.Credentials} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Credentials, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Credentials|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Survey survey = 2;
 * @return {?proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.getSurvey = function() {
  return /** @type{?proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey, 2));
};


/**
 * @param {?proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.setSurvey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.clearSurvey = function() {
  return this.setSurvey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountRequest.prototype.hasSurvey = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenges: (f = msg.getChallenges()) && no_jotta_openapi_credentials_pb.Challenges.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.TerminateAccountResponse;
  return proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Challenges;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Challenges.deserializeBinaryFromReader);
      msg.setChallenges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenges();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Challenges.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Challenges challenges = 1;
 * @return {?proto.no.jotta.openapi.Challenges}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.prototype.getChallenges = function() {
  return /** @type{?proto.no.jotta.openapi.Challenges} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Challenges, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Challenges|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.prototype.setChallenges = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.prototype.clearChallenges = function() {
  return this.setChallenges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.prototype.hasChallenges = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    credentials: (f = msg.getCredentials()) && no_jotta_openapi_credentials_pb.Credentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest;
  return proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Credentials;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Credentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Credentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Credentials credentials = 1;
 * @return {?proto.no.jotta.openapi.Credentials}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.prototype.getCredentials = function() {
  return /** @type{?proto.no.jotta.openapi.Credentials} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Credentials, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Credentials|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} returns this
*/
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenges: (f = msg.getChallenges()) && no_jotta_openapi_credentials_pb.Challenges.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse;
  return proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Challenges;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Challenges.deserializeBinaryFromReader);
      msg.setChallenges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenges();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Challenges.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Challenges challenges = 1;
 * @return {?proto.no.jotta.openapi.Challenges}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.prototype.getChallenges = function() {
  return /** @type{?proto.no.jotta.openapi.Challenges} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Challenges, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Challenges|undefined} value
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse} returns this
*/
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.prototype.setChallenges = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.prototype.clearChallenges = function() {
  return this.setChallenges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.prototype.hasChallenges = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest;
  return proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invite_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest.prototype.setInviteCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse;
  return proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest;
  return proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invite_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest.prototype.setInviteCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse;
  return proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    state: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest;
  return proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getState();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool state = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.prototype.getState = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusMap: (f = msg.getStatusMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse;
  return proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getStatusMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readBool, null, "", false);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatusMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeBool);
  }
};


/**
 * map<string, bool> status = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,boolean>}
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.prototype.getStatusMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,boolean>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse} returns this
 */
proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.prototype.clearStatusMap = function() {
  this.getStatusMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.ApproveLoginRequest;
  return proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string login_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.prototype.getLoginCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginRequest.prototype.setLoginCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.ApproveLoginResponse;
  return proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    federatedToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest;
  return proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFederatedToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFederatedToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string federated_token = 1;
 * @return {string}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.prototype.getFederatedToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} returns this
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest.prototype.setFederatedToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse;
  return proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.AccountType = {
  UNKNOWN_ACCOUNT_TYPE: 0,
  CONSUMER: 1,
  BUSINESS_USER: 2,
  BUSINESS_ADMIN: 3,
  FAMILY_MEMBER: 4,
  FAMILY_OWNER: 5
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.SubscriptionType = {
  UNKNOWN_SUBSCRIPTION_TYPE: 0,
  FREE: 1,
  LIMITED: 2,
  UNLIMITED: 3,
  UUNLIMITED: 4
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.LockCause = {
  UNKNOWN_LOCK_CAUSE: 0,
  PAYMENT_LOCK: 1,
  EXPIRE_LOCK: 2,
  BUSINESS_LOCK: 3,
  BREACH_LOCK: 4
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.PhotoState = {
  UNKNOWN_PHOTO_STATE: 0,
  NOT_ACTIVE: 1,
  QUEUED: 2,
  INIT_IMPORT: 3,
  IMPORTING: 4,
  IMPORT_FINISHED: 5
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.QuotaState = {
  QUOTA_STATE_UNKNOWN: 0,
  VALID: 1,
  SOON_FULL: 2,
  FULL: 3
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.InviteState = {
  UNKNOWN: 0,
  INVITE_CREATED: 1,
  INVITE_SENT: 2,
  INVITE_ACCEPTED: 3,
  INVITE_CANCELED: 4
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.customer.v2.TerminationSurveyCategory = {
  SURVEY_CATEGORY_UNKNOWN: 0
};

goog.object.extend(exports, proto.no.jotta.openapi.customer.v2);
